import { render, staticRenderFns } from "./StanoviskoPlyn.vue?vue&type=template&id=d6fc8f24"
import script from "./StanoviskoPlyn.vue?vue&type=script&lang=js"
export * from "./StanoviskoPlyn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports